export const BUSINESSES_ACL_STALE = 60 * 1000
